import { useRouter } from 'next/router'
import React, { useCallback, useMemo } from 'react'
import { useCurrentLocale } from '../../src/contexts/CurrentLanguageContext'
import { VendorFragment, VendorType } from '../../src/model/fragments'
import { getLocale } from '../../src/model/locale'
import { getPlaceLink } from '../../src/model/urls'
import { VendorMarker } from './VendorMarker'

export interface VendorMarkersProps {
	places: VendorFragment[]
	selectedPlace: null | string
	setSelectedPlace: (id: null | string) => void
}

export const VendorMarkers: React.FC<
	VendorMarkersProps
> = ({ setSelectedPlace, selectedPlace, places }) => {

	const loc = useCurrentLocale()
	const router = useRouter()
	const markerPlaces = useMemo(() => {

		places = places.filter(place => { 
			const locale = getLocale(place.locales, [loc]);
			return !locale || locale.active === undefined || locale.active;
		})

		if (!places) {
			return places
		}

		return places.filter(place => { 
			const locale = getLocale(place.locales, [loc]);
			return locale && locale.active;
		})
	}, [places, places])

	const onMarkerClick = useCallback(
		(place: VendorFragment) => {
			if (place.type === VendorType.showroom && place.link) {
				const link = getPlaceLink(loc, place.id, place.link.url)
				router.push(link.href, link.as)
			} else {
				setSelectedPlace(place.id)
			}
		},
		[loc, router, setSelectedPlace],
	)

	return (
		<>
			{markerPlaces.map((place) => (
				<VendorMarker
					key={place.id}
					place={place}
					isSelected={selectedPlace === place.id}
					onClick={onMarkerClick}
				/>
			))}
		</>
	)
}
